export default "__VITE_ASSET__D2sWGl4g__"